import * as Accordion from "@radix-ui/react-accordion";

export const BaseMultipleAccordion = (
  props: Omit<Accordion.AccordionMultipleProps, "type">
) => {
  return <Accordion.Root {...props} type="multiple" />;
};
